<template>
    <section class="docmain-section">
        <div class="container">
            <div class="row">
                <div class="col-xl-9 col-lg-8">
                    <div class="docmain-container">
                        <div class="getting-details">
                            <p>{{ $t("home.header.Gmail") }}</p><img src="/img/up-arrow.7f2fb856.svg" alt="logo" class="right-arrow"><a href="#">{{ $t('Advance.Channels.Email.Gmail.AddForwardingEmail.tittle') }}</a>
                        </div>
                      
                        <div class="Introduction-details text-align-left">
                            <h1>{{ $t('Advance.Channels.Email.Gmail.AddForwardingEmail.forwardingAddress') }}</h1>
                        </div>
                        <div class="channels-info break-word code-info">
                            <div class="channels-title channels-anchor">

                                <div class="theme-doc-markdown markdown">
                                    <p><strong>{{ $t('Advance.Channels.Email.Gmail.AddForwardingEmail.step1') }}</strong>{{ $t('Advance.Channels.Email.Gmail.AddForwardingEmail.gmailInbox') }}</p>
                                    <p><img alt="gmail_inbox" src="../../../../../../assets/images/gmail_inboxnew.png"
                                            class="max-img"></p>
                                    <p><strong>{{ $t('Advance.Channels.Email.Gmail.AddForwardingEmail.step2') }}</strong>{{ $t('Advance.Channels.Email.Gmail.AddForwardingEmail.allSettings') }}</p>
                                    <p><img alt="gmail_quick_settings"
                                            src="../../../../../../assets/images/gmail_quick_settingsnew.png"
                                            class="max-img"></p>
                                    <p><strong>{{ $t('Advance.Channels.Email.Gmail.AddForwardingEmail.step3') }}</strong>{{ $t('Advance.Channels.Email.Gmail.AddForwardingEmail.select') }}</p>
                                    <p><img alt="gmail_imap_settings"
                                            src="../../../../../../assets/images/gmail_imap_settingsnew.png"
                                            class="max-img"></p>
                                    <p><strong>{{ $t('Advance.Channels.Email.Gmail.AddForwardingEmail.step4') }}</strong>{{ $t('Advance.Channels.Email.Gmail.AddForwardingEmail.clickOn') }}</p>
                                    <p><img alt="forwarding_address"
                                            src="../../../../../../assets/images/forwarding_address.png" class="max-img">
                                    </p>
                                    <p><strong>{{ $t('Advance.Channels.Email.Gmail.AddForwardingEmail.step5') }}</strong>{{ $t('Advance.Channels.Email.Gmail.AddForwardingEmail.addEmail') }}</p>
                                    <p><img alt="add_forwarding_address"
                                            src="../../../../../../assets/images/add_forwarding_address.png"
                                            class="max-img"></p>
                                    <p><strong>{{ $t('Advance.Channels.Email.Gmail.AddForwardingEmail.step6') }}</strong>{{ $t('Advance.Channels.Email.Gmail.AddForwardingEmail.confirm') }}</p>
                                    <p><strong>{{ $t('Advance.Channels.Email.Gmail.AddForwardingEmail.step7') }}</strong>{{ $t('Advance.Channels.Email.Gmail.AddForwardingEmail.copy') }}</p>
                                    <p><strong>{{ $t('Advance.Channels.Email.Gmail.AddForwardingEmail.step8') }}</strong>{{ $t('Advance.Channels.Email.Gmail.AddForwardingEmail.verify') }}
                                    </p>
                                    <p><img alt="verify_forwarding_address"
                                            src="../../../../../../assets/images/verify_forwarding_address.png"
                                            class="max-img"></p>
                                    <p><strong>{{ $t('Advance.Channels.Email.Gmail.AddForwardingEmail.step9') }}</strong>{{ $t('Advance.Channels.Email.Gmail.AddForwardingEmail.verification') }}
                                    </p>
                                    <p><strong>{{ $t('Advance.Channels.Email.Gmail.AddForwardingEmail.step10') }}</strong>{{ $t('Advance.Channels.Email.Gmail.AddForwardingEmail.selectForward') }}
                                    </p>
                                    <p><img alt="choose_forward_option"
                                            src="../../../../../../assets/images/generate_password.png" class="max-img">
                                    </p>
                                </div>

                            </div>
                        </div>
                        <div class="edit-update-detail">
                            <!-- <div class="edit-pen">
                                <svg fill="currentColor" height="20" width="20" viewBox="0 0 40 40" class="iconEdit_dcUD"
                                    aria-hidden="true">
                                    <g>
                                        <path
                                            d="m34.5 11.7l-3 3.1-6.3-6.3 3.1-3q0.5-0.5 1.2-0.5t1.1 0.5l3.9 3.9q0.5 0.4 0.5 1.1t-0.5 1.2z m-29.5 17.1l18.4-18.5 6.3 6.3-18.4 18.4h-6.3v-6.2z">
                                        </path>
                                    </g>
                                </svg>
                                <a href="#">{{ $t('Advance.Channels.Email.Gmail.AddForwardingEmail.editPage') }}</a>
                            </div> -->
                            <p>{{ $t('Advance.Channels.Email.Gmail.AddForwardingEmail.lastUpdatedOn') }} <span class="dark"> {{ $t('Advance.Channels.Email.Gmail.AddForwardingEmail.date') }} </span> {{ $t('Advance.Channels.Email.Gmail.AddForwardingEmail.by') }} <span class="dark"> {{ $t('Advance.Channels.Email.Gmail.AddForwardingEmail.hrichaShandily') }}
                                </span></p>
                        </div>
                        <div class="row">
                            <div class="col-lg-6">
                                <div class="create-chat-woot-account">
                                    <p class="preview">{{ $t('Advance.Channels.Email.Gmail.AddForwardingEmail.previous') }}</p>


                                    <router-link to="/docs/product/channels/email/gmail/generate-app-password"
                                        class="introduction-account">
                                        <span>{{ $t('Advance.Channels.Email.Gmail.AddForwardingEmail.side') }}</span> {{ $t('Advance.Channels.Email.Gmail.AddForwardingEmail.imap') }}
                                    </router-link>
                                </div>
                            </div>
                            <div class="col-lg-6">
                                <div class="create-chat-woot-account">
                                    <p>{{ $t('Advance.Channels.Email.Gmail.AddForwardingEmail.next') }}</p>



                                    <router-link to="/docs/product/channels/email/microsoft/create-channel">
                                        {{ $t('Advance.Channels.Email.Gmail.AddForwardingEmail.createChannel') }} <span>{{ $t('Advance.Channels.Email.Gmail.AddForwardingEmail.arrow') }}</span>
                                    </router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xl-3 col-lg-4">

                </div>
            </div>
        </div>
    </section>
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import SideBar from "@/components/SideBar.vue";
import MainContent from "@/components/MainContent.vue";

export default {
    name: 'generate-app-password',
    data() {
        return {
            isToggle: false
        }
    },
    components: {
        Header,
        Footer,
        SideBar,
        MainContent
    },
    methods: {
        handleToggle() {
            this.isToggle = !this.isToggle
        }
    },
}
</script>

<style>
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 0px;
}
</style>
